module.exports = __webpack_public_path__ + "img/back centered zipper length.2f213bb0.png";